/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

const isElementVisibleAndEnabled = (elem) => {
    if (!elem) {
        return false;
    }
    if (elem.disabled) {
        return false;
    }
    if (elem.tagName === 'INPUT' && elem.type === 'hidden') {
        return false;
    }
    const { visibility, display } = getComputedStyle(elem);
    if (visibility === 'hidden' || display === 'none') {
        return false;
    }
    // display: contents should defer its visible/enabled definition to its first child
    // Semantically, display: contents makes an element act like it's not part of the layout,
    // so we should not consider it for visibility here
    if (display === 'contents') {
        return isElementVisibleAndEnabled(elem.firstElementChild);
    }
    const boundingRect = elem.getBoundingClientRect();
    return boundingRect.width > 0 && boundingRect.height > 0;
};

export default isElementVisibleAndEnabled;
